import { motion } from "framer-motion";
import { 
  FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, 
  FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaUserCircle 
} from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Fotter() {
  const currentYear = new Date().getFullYear();

  return (
    <motion.footer
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
      style={ui.footer}
    >
      <div style={ui.container}>
        <div style={ui.grid}>
          
          {/* Column 1: Brand Info */}
          <div style={ui.column}>
            <div style={ui.brandContainer}>
              <div style={ui.logoBox}>GM</div>
              <h2 style={ui.brandName}>Girraj <span style={{color: '#3b82f6'}}>Medicare</span></h2>
            </div>
            <p style={ui.description}>
              Revolutionizing healthcare accessibility with advanced diagnostics and 
              seamless pharmaceutical delivery. Your health, our priority.
            </p>
            <div style={ui.socialRow}>
              {[FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn].map((Icon, i) => (
                <motion.a 
                  key={i} href="#" whileHover={{ y: -5, color: '#3b82f6' }} 
                  style={ui.socialIcon}
                >
                  <Icon size={18} />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Column 2: Quick Navigation */}
          <div style={ui.column}>
            <h3 style={ui.colTitle}>Quick Links</h3>
            <ul style={ui.linkList}>
              <FooterLink to="/">Home</FooterLink>
              <FooterLink to="/about">About Us</FooterLink>
              <FooterLink to="/order">Order Medicine</FooterLink>
              <FooterLink to="/lab-tests">Lab Tests</FooterLink>
              <FooterLink to="/contact">Contact Support</FooterLink>
            </ul>
          </div>

          {/* Column 3: Contact Details */}
          <div style={ui.column}>
            <h3 style={ui.colTitle}>Get In Touch</h3>
            <div style={ui.contactInfo}>
              <div style={ui.contactItem}>
                <FaMapMarkerAlt style={ui.icon} color="#3b82f6" />
                <span>123 Medical Square, Gwalior, MP</span>
              </div>
              <div style={ui.contactItem}>
                <FaPhoneAlt style={ui.icon} color="#3b82f6" />
                <span>+91 98765 43210</span>
              </div>
              <div style={ui.contactItem}>
                <FaEnvelope style={ui.icon} color="#3b82f6" />
                <span>care@girrajmedical.com</span>
              </div>
            </div>
            <Link to="/login" style={ui.authButton}>
              <FaUserCircle size={20} />
              <span>Patient Portal</span>
            </Link>
          </div>

        </div>

        {/* Bottom Bar */}
        <div style={ui.bottomBar}>
          <p>© {currentYear} Girraj Medicare. All rights reserved.</p>
          <div style={ui.bottomLinks}>
            <a href="#" style={ui.bLink}>Privacy Policy</a>
            <a href="#" style={ui.bLink}>Terms of Service</a>
          </div>
        </div>
      </div>
    </motion.footer>
  );
}

// Helper Component for Animated Links
const FooterLink = ({ to, children }) => (
  <motion.li whileHover={{ x: 5 }} style={{ listStyle: 'none' }}>
    <Link to={to} style={ui.link}>{children}</Link>
  </motion.li>
);

const ui = {
  footer: {
    width: "100%",
    background: "#0f172a", // Deep Navy/Slate
    color: "#cbd5e1",
    padding: "80px 0 30px 0",
    position: "relative",
    overflow: "hidden",
    borderTop: "1px solid rgba(255, 255, 255, 0.05)",
    fontFamily: "'Poppins', sans-serif",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "40px",
    marginBottom: "60px",
  },
  column: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  brandContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  logoBox: {
    background: "#3b82f6",
    color: "white",
    padding: "8px 12px",
    borderRadius: "10px",
    fontWeight: "900",
    fontSize: "1.2rem",
  },
  brandName: {
    fontSize: "1.5rem",
    color: "white",
    margin: 0,
    fontWeight: "700",
  },
  description: {
    fontSize: "0.9rem",
    lineHeight: "1.6",
    color: "#94a3b8",
  },
  socialRow: {
    display: "flex",
    gap: "15px",
    marginTop: "10px",
  },
  socialIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    background: "rgba(255,255,255,0.03)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    transition: "0.3s",
    textDecoration: "none",
  },
  colTitle: {
    fontSize: "1.1rem",
    color: "white",
    fontWeight: "600",
    marginBottom: "10px",
    position: "relative",
  },
  linkList: {
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  link: {
    color: "#94a3b8",
    textDecoration: "none",
    fontSize: "0.95rem",
    transition: "0.3s",
  },
  contactInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  contactItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    fontSize: "0.9rem",
  },
  icon: {
    marginTop: "3px",
  },
  authButton: {
    marginTop: "10px",
    background: "rgba(59, 130, 246, 0.1)",
    border: "1px solid rgba(59, 130, 246, 0.2)",
    color: "#3b82f6",
    padding: "12px 20px",
    borderRadius: "12px",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    fontWeight: "600",
    transition: "0.3s",
  },
  bottomBar: {
    borderTop: "1px solid rgba(255, 255, 255, 0.05)",
    paddingTop: "30px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "0.85rem",
    color: "#64748b",
  },
  bottomLinks: {
    display: "flex",
    gap: "20px",
  },
  bLink: {
    color: "#64748b",
    textDecoration: "none",
    transition: "0.3s",
  }
};